// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:1904px){.container{max-width:1185px}}.w-page-login,.w-page-password_reset_confirmation,.w-page-register{max-width:700px}.body2{color:#111212;text-align:center;justify-content:center}@media (min-width:992px){.body2{font-size:16px}}@media (max-width:768px){.body2{font-size:12px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
